import { render, staticRenderFns } from "./AccountFlow.vue?vue&type=template&id=2fee812b&scoped=true&"
import script from "./AccountFlow.vue?vue&type=script&lang=js&"
export * from "./AccountFlow.vue?vue&type=script&lang=js&"
import style0 from "./AccountFlow.vue?vue&type=style&index=0&id=2fee812b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fee812b",
  null
  
)

export default component.exports